import type { FC } from 'react'
import { ReactNode } from 'react'
import { Box } from '@mui/material'

type Props = {
  tableHeaderBar?: ReactNode
}

export const DataGridHeaderBar: FC<Props> = ({ tableHeaderBar }) => (
  <Box data-test="datagrid-actionbar">{tableHeaderBar}</Box>
)

export type DataGridHeaderBarProps = Props
